import { CSSObject } from "@emotion/react";
import { CheckboxStyleOverrides } from "@newsela/angelou";

export const checkboxCss = (
  overrideLabelStyles: CSSObject,
): CheckboxStyleOverrides<CSSObject> => ({
  root: {
    padding: "4px",
  },

  labelText: {
    display: "flex",
    flexDirection: "row-reverse",
    marginLeft: "-5px",

    svg: {
      width: "24px",
      height: "auto",
      marginRight: "4px",
    },
    ...overrideLabelStyles,
  },
});
